export default {
    h5: {
        generateSignUrl: "/gateway/huilian/signManagecs/generateSignUrl", //生成签署链接
        checkCertification:
            "/gateway/huilianCust/certificationcs/checkCertification", //校验是否实名
        selectSignPlatForm: "/gateway/huilian/signManagecs/selectSignPlatForm",
    },
    wechat: {
        generateSignUrl: "/gateway/huilian/signManagecs/generateSignUrl", //生成签署链接
        checkCertification:
            "/gateway/huilianCust/certificationcs/checkCertification", //校验是否实名
        selectSignPlatForm: "/gateway/huilian/signManagecs/selectSignPlatForm",
    },
};



// WEBPACK FOOTER //
// ./src/authCertificate/ACFaceCa/api.js